import { render, staticRenderFns } from "./RootsAndDegreesExamplesViewer.vue?vue&type=template&id=c25965c8&scoped=true&lang=pug&"
import script from "./RootsAndDegreesExamplesViewer.vue?vue&type=script&lang=js&"
export * from "./RootsAndDegreesExamplesViewer.vue?vue&type=script&lang=js&"
import style0 from "./RootsAndDegreesExamplesViewer.vue?vue&type=style&index=0&id=c25965c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c25965c8",
  null
  
)

export default component.exports